module.exports = __webpack_public_path__ + "5087c54d01b13acd40a4a3e24c084c79.fbx";